import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconMap = createIcon({
  displayName: 'IconMap',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M22 22.6199L14.92 19.0799L8.92 21.0799L2 17.6199V1.37988L9.08 4.91988L15.08 2.91988L22 6.37988V22.6199ZM15.08 16.9199L20 19.3799V7.61988L14.92 5.07988L8.92 7.07988L4 4.61988V16.3799L9.08 18.9199L15.08 16.9199ZM10 9H8V17H10V9ZM14 7H16V15H14V7Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
